<template>
  <!-- PDF Content Here -->
  <div>
    <div class="row">
      <div class="col-6 pl-3 p-2">
        <span class="brand-logo"><b-img :src="appLogoImage" alt="logo" /></span>
      </div>
      <div class="col-6 text-right">
        INTERNATIONAL LOGISTICS CORPORATION <br />
        5th Fl, Saigon Port Building<br />
        No.3 Nguyen Tat Thanh St, Ward 13, Dist 4, HCMC, Vietnam <br />
        Tel: 08 394 35 899 - Fax: 08 394 35 898<br />
      </div>
    </div>
    <div class="row">
      <div class="col-12 text-center">
        <div class="TH">
          <h3>P/E SHEET</h3>
          <h3>(SERVICE)</h3>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-9"></div>
      <div class="col-3 justify-content-right">
        <div class="info-pr">
          <ul>
            <li>
              <span>Saler WR1</span>
            </li>
            <li><span>Phone:</span> 098555789</li>
            <li><span>Create Date:</span> 12/08/2022</li>
          </ul>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-6">
        <div class="info-pr">
          <ul>
            <li><span>Shipment ID:</span> JASK</li>
            <li><span>Origin(POL):</span>wr1</li>
            <li><span>MBL</span></li>
            <li><span>Shipper:</span>Thanh cry</li>
            <li><span>Vessel/Voy</span></li>
            <li><span>Qty/CTNS:</span> 30</li>
            <li><span>REVENUW:</span> 30</li>
          </ul>
        </div>
      </div>
      <div class="col-6">
        <div class="row">
          <div class="col-6">
            <div class="info-pr">
              <ul>
                <li><span>ETD/ETA:</span> JASK</li>
                <li><span>Dest(POL):</span>wr1</li>
                <li><span>HBL</span></li>
                <li><span>Consignee:</span>Thanh cry</li>
                <li><span>GW/CBM</span></li>
                <li><span>Cont/seal:</span> 30</li>
                <!-- <li><span>REVENUW:</span> 30</li> -->
              </ul>
            </div>
          </div>
          <div class="col-6">
            <div class="info-pr">
              <ul>
                <li><span>Booking no</span></li>
                <li><span>Creat Date:</span></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="html2pdf__page-break1" /> -->
    <!-- pricing -->
    <div class="row mt-1">
      <h5 class="pl-2">I REVENUE</h5>
      <div class="col-12 text-center">
        <table
          class="table-print"
          v-if="fee_types != null && unit_types != null"
        >
          <thead>
            <tr>
              <th>Paybale Acc</th>
              <th>Description</th>
              <th>Unit</th>
              <th>Unit Price</th>
              <th>Quantity</th>
              <th>Amount</th>
              <th>Sale VND</th>
              <th>Sale USD</th>
              <th>Note</th>
            </tr>
          </thead>
          <tbody v-for="c in cost_booking" :key="c.id">
            <tr v-for="(i, index) in c.detail" :key="i.fee_type + index">
              <td v-if="i.checked">
                {{
                  companyItems.filter((k) => k.id == i.payableAcc)[0]
                    ? companyItems.filter((k) => k.id == i.payableAcc)[0].name
                    : ""
                }}
              </td>
              <td v-if="i.checked">
                <!-- {{ fee_types.filter((k) => k.id == i.fee_type)[0].text }} -->
                {{
                  fee_types.filter((k) => k.id == i.fee_type).length > 0
                    ? fee_types.filter((k) => k.id == i.fee_type)[0].text
                    : ""
                }}
              </td>
              <td v-if="i.checked">
                {{
                  unit_types.filter((k) => k.id == i.unit).length > 0
                    ? unit_types.filter((k) => k.id == i.unit)[0].text
                    : ""
                }}
              </td>
              <td class="text-right" v-if="i.checked">{{ i.unit_price }}</td>
              <td class="text-right" v-if="i.checked">{{ i.qty }}</td>
              <!-- mout -->
              <td class="text-right" v-if="i.checked">
                {{
                  i.currency == "USD"
                    ? FNUSD(
                        i.qty * (i.unit_price + "").replace(/,/g, "") +
                          i.qty *
                            (i.unit_price + "").replace(/,/g, "") *
                            (i.vat ? i.vat / 100 : "0")
                      )
                    : FN(
                        i.qty *
                          (i.unit_price + "")
                            .replace(/\./g, "")
                            .replace(/,/g, "") +
                          i.qty *
                            (i.unit_price + "")
                              .replace(/\./g, "")
                              .replace(/,/g, "") *
                            (i.vat ? i.vat / 100 : "0")
                      )
                }}
                {{ " " + i.currency + " " + " (" + i.vat + "%" + ")" }}
              </td>
              <!-- vnd -->
              <td class="text-right" v-if="i.checked">
                {{
                  i.currency == "VND"
                    ? FN(
                        i.qty *
                          (i.unit_price + "")
                            .replace(/\./g, "")
                            .replace(/,/g, "") +
                          i.qty *
                            (i.unit_price + "")
                              .replace(/\./g, "")
                              .replace(/,/g, "") *
                            (i.vat ? i.vat / 100 : "0")
                      )
                    : FN(
                        (i.qty * (i.unit_price + "").replace(/,/g, "") +
                          i.qty *
                            (i.unit_price + "").replace(/,/g, "") *
                            (i.vat ? i.vat / 100 : "0")) *
                          exchangeRate
                      )
                }}
              </td>
              <!-- usd -->
              <td class="text-right" v-if="i.checked">
                {{
                  i.currency == "USD"
                    ? FNUSD(
                        i.qty * (i.unit_price + "").replace(/,/g, "") +
                          i.qty *
                            (i.unit_price + "").replace(/,/g, "") *
                            (i.vat ? i.vat / 100 : "0")
                      )
                    : FNUSD(
                        (i.qty * (i.unit_price + "").replace(/,/g, "") +
                          i.qty *
                            (i.unit_price + "").replace(/,/g, "") *
                            (i.vat ? i.vat / 100 : "0")) /
                          exchangeRate
                      )
                }}
              </td>
              <td v-if="i.checked">{{ i.notes }}</td>
            </tr>
          </tbody>
          <tbody v-for="c in currencies" :key="c.id">
            <tr v-if="getTotal(c.id) > 0">
              <td colspan="5"></td>
              <td class="text-center">
                <b><span>Subtotal</span></b>
              </td>
              <td class="text-right">
                <b>{{ FN(getVND_Bk(c.id)) }}</b>
              </td>
              <td class="text-right">
                <b>{{ FNUSD(getUSD_Bk(c.id)) }}</b>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- costs -->
    <div class="row mt-1">
      <h5 class="pl-2">II COST</h5>
      <div class="col-12 text-center">
        <table
          class="table-print"
          v-if="fee_types != null && unit_types != null"
        >
          <thead>
            <tr>
              <th>Paybale Acc</th>
              <th>Description</th>
              <th>Unit</th>
              <th>Unit Price</th>
              <th>Quantity</th>
              <th>Amount</th>
              <th>Sale VND</th>
              <th>Sale USD</th>
              <th>Note</th>
            </tr>
          </thead>
          <tbody v-for="c in cost_info" :key="c.id">
            <tr v-for="(i, index) in c.detail" :key="i.fee_type + index">
              <td v-if="i.checked">
                {{
                  companyItems.filter((k) => k.id == i.payableAcc)[0]
                    ? companyItems.filter((k) => k.id == i.payableAcc)[0].name
                    : ""
                }}
              </td>
              <td v-if="i.checked">
                <!-- {{ fee_types.filter((k) => k.id == i.fee_type)[0].text }} -->
                {{
                  fee_types.filter((k) => k.id == i.fee_type).length > 0
                    ? fee_types.filter((k) => k.id == i.fee_type)[0].text
                    : ""
                }}
              </td>
              <td v-if="i.checked">
                {{
                  unit_types.filter((k) => k.id == i.unit).length > 0
                    ? unit_types.filter((k) => k.id == i.unit)[0].text
                    : ""
                }}
              </td>
              <td class="text-right" v-if="i.checked">{{ i.unit_price }}</td>
              <td class="text-right" v-if="i.checked">{{ i.qty }}</td>
              <!-- mout -->
              <td class="text-center" v-if="i.checked">
                {{
                  i.currency == "USD"
                    ? FNUSD(
                        i.qty * (i.unit_price + "").replace(/,/g, "") +
                          i.qty *
                            (i.unit_price + "").replace(/,/g, "") *
                            (i.vat ? i.vat / 100 : "0")
                      )
                    : FN(
                        i.qty *
                          (i.unit_price + "")
                            .replace(/\./g, "")
                            .replace(/,/g, "") +
                          i.qty *
                            (i.unit_price + "")
                              .replace(/\./g, "")
                              .replace(/,/g, "") *
                            (i.vat ? i.vat / 100 : "0")
                      )
                }}
                {{ " " + i.currency + " " + "(" + i.vat + "%" + ")" }}
              </td>
              <!-- vnd -->
              <td class="text-right" v-if="i.checked">
                {{
                  i.currency == "VND"
                    ? FNUSD(
                        i.qty *
                          (i.unit_price + "")
                            .replace(/,/g, "") +
                          i.qty *
                            (i.unit_price + "")
                              .replace(/\./g, "")
                              .replace(/,/g, "") *
                            (i.vat ? i.vat / 100 : "0")
                      )
                    : FN(
                        Math.round(
                          (i.qty * (i.unit_price + "").replace(/,/g, "") +
                            i.qty *
                              (i.unit_price + "").replace(/,/g, "") *
                              (i.vat ? i.vat / 100 : "0")) *
                            exchangeRate
                        )
                      )
                }}
              </td>
              <!-- usd -->
              <td class="text-right" v-if="i.checked">
                {{
                  i.currency == "USD"
                    ? FNUSD(
                        i.qty * (i.unit_price + "").replace(/,/g, "") +
                          i.qty *
                            (i.unit_price + "").replace(/,/g, "") *
                            (i.vat ? i.vat / 100 : "0")
                      )
                    : FN(
                        (i.qty *
                          (i.unit_price + "")
                            .replace(/\./g, "")
                            .replace(/,/g, "") +
                          (i.qty *
                            (i.unit_price + "")
                              .replace(/\./g, "")
                              .replace(/,/g, "") *
                            i.vat) /
                            100) /
                        exchangeRate
                      ).toFixed(0)
                }}
              </td>
              <td v-if="i.checked">{{ i.notes }}</td>
            </tr>
          </tbody>
          <tbody v-for="c in currencies" :key="c.id">
            <tr v-if="getTotal(c.id) > 0">
              <td colspan="5"></td>
              <td class="text-center">
                <b><span>Subtotal</span></b>
              </td>
              <td class="text-right">
                <b>{{ FN(getVND_Ci(c.id)) }}</b>
              </td>
              <td class="text-right">
                <b>{{ FNUSD(getUSD_Ci(c.id)) }}</b>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- grandtotal -->
    <div class="row mt-1">
      <div class="col-7"></div>
      <div class="col-5 text-right" style="padding-right: 70px">
        <table
          class="table-print"
          v-if="fee_types != null && unit_types != null"
        >
          <thead></thead>
          <tbody v-for="c in currencies" :key="c.id">
            <tr v-if="getTotal(c.id) > 0">
              <td colspan="2" class="text-center" s>
                <b><span>Grandtotal</span></b>
              </td>
              <td colspan="" class="text-center" style="padding: 0 19px">
                <b>{{ FN(getTotalVND(c.id)) }}</b>
              </td>
              <td colspan="" class="text-center" style="padding: 0 19px">
                <b>{{ FNUSD(getTotalUSD(c.id)) }}</b>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <!-- prepair -->
    <div class="row mt-1">
      <div class="col-3">
        <h5>Prepaired</h5>
      </div>
      <div class="col-3">
        <div class="jkh">
          <h5>User preview</h5>
        </div>
      </div>
      <div class="col-3">
        <div class="jkh">
          <h5>Verified by</h5>
          <p class="pt-2">Date:</p>
        </div>
      </div>
      <div class="col-3">
        <div class="jkh">
          <h5>Approved by</h5>
          <p class="pt-2">Date:</p>
        </div>
      </div>
    </div>
    <div class="row mt-1">
      <div class="col-6">
        HO CHI MINH HEAD OFFICE<br />
        1st, Saigon Port Building,<br />
        3 Nguyen Tat Thanh St, Ward 13, Dist 4, HCMC, Vietnam <br />
        Tel: 84-28-3943-5899<br />
      </div>
      <div class="col-6">
        HAI PHONG OFFICE<br />
        Office: 5th Floor,Thanh Dat 1 building<br />
        No.3 Le Thanh Tong, Ngo Quyen Dist, Hai Phong, Vietnam <br />
        Tel: 84-225-3250-476<br />
      </div>
    </div>
  </div>
</template>
<style>
.table-print td {
  text-align: left;
}
.table-print th {
  text-align: center !important;
}
.table-print td,
.table-print th {
  border-bottom: 1px solid #333 !important;
  /* border-right: 1px solid #333 !important; */
  border-top: 1px solid #333 !important;
  padding: 4px 6px;
}
.table-print th {
  padding-top: 12px;
  padding-bottom: 12px;
  text-align: left;
  background-color: #2b938c;
  color: white;
}
.info-pr li {
  list-style: none;
}
</style>
<script>
import {
  BImg,
  BDropdown,
  BDropdownItem,
  BButton,
  BFormTextarea,
  BFormInput,
  BFormCheckbox,
  BFormRadioGroup,
  BFormRadio,
  BFormGroup,
  BInputGroup,
  BInputGroupAppend,
  BInputGroupPrepend,
  BFormDatepicker,
  BRow,
  BCol,
  BTable,
  BCard,
  BCardText,
} from "bootstrap-vue";
import VueHtml2pdf from "vue-html2pdf";
import FeatherIcon from "@/@core/components/feather-icon/FeatherIcon.vue";
import { mapState, mapActions } from "vuex";
export default {
  props: {
    cards: {},
    booking: { default: null },
    costs_info: { default: null },
    companyItems: { default: null },
    vat: { default: null },
    pay: { default: null },
    fee_types: { default: null },
    unit_types: { default: null },
    currencies: { default: null },
    request_quotation: { default: null },
    service_types: { default: null },
    locations: { default: null },
  },
  components: {
    BImg,
    VueHtml2pdf,
    BDropdown,
    BDropdownItem,
    BButton,
    BFormTextarea,
    BCardText,
    BFormInput,
    BFormCheckbox,
    BFormRadioGroup,
    BFormRadio,
    BFormGroup,
    BInputGroup,
    BInputGroupAppend,
    BInputGroupPrepend,
    BFormDatepicker,
    BRow,
    BCol,
    BTable,
    BCard,
    BCardText,
    FeatherIcon,
  },
  data() {
    return {
      appLogoImage: require("@/assets/images/logo/logo.svg"),
      userData: JSON.parse(localStorage.getItem("userData")),
      quotation: {},
      cost_booking: null,
      cost_info: null,
    };
  },
  created() {
    this.$store.dispatch("masterData/fetchRate");
  },
  mounted() {
    if (this.request_quotation != null && this.service_types != null) {
      this.quotation = this.request_quotation;
    }
    if (this.booking != null) {
      this.cost_booking = this.booking.costs;
    }
    if (this.costs_info != null) {
      this.cost_info = this.costs_info.costs;
    }
    if (this.costs_info == null) {
      this.cost_info = this.booking.costs;
    }
    if (this.booking == null) {
      this.cost_booking = this.costs_info.costs;
    }
  },
  methods: {
    getTotal(currency) {
      if (this.cost_booking != null) {
        var t = 0;
        this.cost_booking.forEach((c) => {
          c.detail.forEach((i) => {
            if (i.checked && i.currency == currency) {
              t += i.qty * (i.unit_price + "").replace(/,/g, "");
            }
          });
        });
        return t;
      }
      if (this.cost_info != null) {
        var t = 0;
        this.cost_info.forEach((c) => {
          c.detail.forEach((i) => {
            if (i.checked && i.currency == currency) {
              t += i.qty * (i.unit_price + "").replace(/,/g, "");
            }
          });
        });
        return t;
      }
    },
    getVND_Bk() {
      if (this.cost_booking) {
        var coi = 0;
        this.cost_booking.forEach((c) => {
          c.detail.forEach((i) => {
            if (i.checked && i.currency == "VND") {
              coi +=
                i.qty *
                  (i.unit_price + "").replace(/\./g, "").replace(/,/g, "") +
                i.qty *
                  (i.unit_price + "").replace(/\./g, "").replace(/,/g, "") *
                  (i.vat ? i.vat / 100 : "0");
            } else {
              coi +=
                (i.qty * (i.unit_price + "").replace(/,/g, "") +
                  i.qty *
                    (i.unit_price + "").replace(/,/g, "") *
                    (i.vat ? i.vat / 100 : "0")) *
                this.exchangeRate;
            }
          });
        });
        return coi;
      }
    },
    getVND_Ci() {
      if (this.cost_info) {
        var coi = 0;
        this.cost_info.forEach((c) => {
          c.detail.forEach((i) => {
            if (i.checked && i.currency == "VND") {
              coi +=
                i.qty *
                  (i.unit_price + "").replace(/\./g, "").replace(/,/g, "") +
                i.qty *
                  (i.unit_price + "").replace(/\./g, "").replace(/,/g, "") *
                  (i.vat ? i.vat / 100 : "0");
            } else {
              coi += Math.round(
                (i.qty * (i.unit_price + "").replace(/,/g, "") +
                  i.qty *
                    (i.unit_price + "").replace(/,/g, "") *
                    (i.vat ? i.vat / 100 : "0")) *
                  this.exchangeRate
              );
            }
          });
        });
        return coi;
      }
    },
    getUSD_Bk() {
      if (this.cost_booking) {
        var coi = 0;
        this.cost_booking.forEach((c) => {
          c.detail.forEach((i) => {
            if (i.checked && i.currency == "USD") {
              coi +=
                i.qty * (i.unit_price + "").replace(/,/g, "") +
                i.qty *
                  (i.unit_price + "").replace(/,/g, "") *
                  (i.vat ? i.vat / 100 : "0");
            } else {
              coi +=
                (i.qty *
                  (i.unit_price + "").replace(/\./g, "").replace(/,/g, "") +
                  (i.qty *
                    (i.unit_price + "").replace(/\./g, "").replace(/,/g, "") *
                    i.vat) /
                    100) /
                this.exchangeRate;
            }
          });
        });
        return coi;
      }
    },
    getUSD_Ci() {
      if (this.cost_info) {
        var coi = 0;
        this.cost_info.forEach((c) => {
          c.detail.forEach((i) => {
            if (i.checked && i.currency == "USD") {
              coi +=
                i.qty * (i.unit_price + "").replace(/,/g, "") +
                i.qty *
                  (i.unit_price + "").replace(/,/g, "") *
                  (i.vat ? i.vat / 100 : "0");
            } else 
          
            {
              coi += (
                (i.qty *
                  (i.unit_price + "").replace(/\./g, "").replace(/,/g, "") +
                  (i.qty *
                    (i.unit_price + "").replace(/\./g, "").replace(/,/g, "") *
                    i.vat) /
                    100) /
                this.exchangeRate
              ).toFixed(2);
            }
          });
        });
        return coi;
      }
    },
    getTotalVND() {
      if (this.cost_booking) {
        var coi1 = 0;
        this.cost_booking.forEach((c) => {
          c.detail.forEach((i) => {
            if (i.checked && i.currency == "VND") {
              coi1 +=
                i.qty *
                  (i.unit_price + "").replace(/\./g, "").replace(/,/g, "") +
                i.qty *
                  (i.unit_price + "").replace(/\./g, "").replace(/,/g, "") *
                  (i.vat ? i.vat / 100 : "0");
            } else {
              coi1 +=
                (i.qty * (i.unit_price + "").replace(/,/g, "") +
                  i.qty *
                    (i.unit_price + "").replace(/,/g, "") *
                    (i.vat ? i.vat / 100 : "0")) *
                this.exchangeRate;
            }
          });
        });
      }
      if (this.cost_info) {
        var coi2 = 0;
        this.cost_info.forEach((c) => {
          c.detail.forEach((i) => {
            if (i.checked && i.currency == "VND") {
              coi2 +=
                i.qty *
                  (i.unit_price + "").replace(/\./g, "").replace(/,/g, "") +
                i.qty *
                  (i.unit_price + "").replace(/\./g, "").replace(/,/g, "") *
                  (i.vat ? i.vat / 100 : "0");
            } else {
              coi2 +=
                (i.qty * (i.unit_price + "").replace(/,/g, "") +
                  i.qty *
                    (i.unit_price + "").replace(/,/g, "") *
                    (i.vat ? i.vat / 100 : "0")) *
                this.exchangeRate;
            }
          });
        });
      }
      return coi1 - coi2;
    },
    getTotalUSD() {
      if (this.cost_booking) {
        var coi1 = 0;
        this.cost_booking.forEach((c) => {
          c.detail.forEach((i) => {
            if (i.checked && i.currency == "USD") {
              coi1 +=
                i.qty * (i.unit_price + "").replace(/,/g, "") +
                i.qty *
                  (i.unit_price + "").replace(/,/g, "") *
                  (i.vat ? i.vat / 100 : "0");
            } else {
              coi1 +=
                (i.qty *
                  (i.unit_price + "").replace(/\./g, "").replace(/,/g, "") +
                  (i.qty *
                    (i.unit_price + "").replace(/\./g, "").replace(/,/g, "") *
                    i.vat) /
                    100) /
                this.exchangeRate;
            }
          });
        });
      }
      if (this.cost_info) {
        var coi2 = 0;
        this.cost_info.forEach((c) => {
          c.detail.forEach((i) => {
            if (i.checked && i.currency == "USD") {
              coi2 +=
                i.qty * (i.unit_price + "").replace(/,/g, "") +
                i.qty *
                  (i.unit_price + "").replace(/,/g, "") *
                  (i.vat ? i.vat / 100 : "0");
            } else {
              coi2 +=
                (i.qty *
                  (i.unit_price + "").replace(/\./g, "").replace(/,/g, "") +
                  (i.qty *
                    (i.unit_price + "").replace(/\./g, "").replace(/,/g, "") *
                    i.vat) /
                    100) /
                this.exchangeRate;
            }
          });
        });
      }
      return coi1 - coi2;
    },

    FN: function (value) {
      try {
        return (value + "")
          .replace(/[^0-9]/g, "")
          .replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1.");
      } catch (err) {
        return value;
      }
    },
    FNVN: function (value) {
      try {
        if (Number(value)) {
          return this.$Utils.formatMooney(
            value.replace(/\./g, "").replace(/,/g, ""),
            "vi-VN"
          );
        }
      } catch (err) {
        return value;
      }
    },
    FNUS: function (value) {
      try {
        if (Number(value)) {
          return this.$Utils.formatMooney(value.replace(/,/g, ""), "en-US");
        }
      } catch (err) {
        return value;
      }
    },
    FNUSD: function (value) {
      try {
        return (value + "")
          .replace(/[^0-9 || \\.]/g, "")
          .replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
      } catch (err) {
        return value;
      }
    },
  },
  computed: {
    exchangeRate: function () {
      return this.$store.getters["masterData/exchangeRate"];
    },
  },
};
</script>